import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × CARTIER: Jewelry-level geometry — millimetric precision
// Faceted curves, ruby red, geometric frames
export function VasarelyCartierMode({ brand }: ModeRendererProps) {
  const cartierRed = "#C8102E";
  const cartierGold = "#D4AF37";

  return (
    <g>
      {/* Luxurious deep background */}
      <rect x="0" y="0" width="794" height="1123" fill="#1A1A1A" />

      <g transform="translate(397 540)">
        {/* Faceted gemstone grid */}
        {Array.from({ length: 10 }).map((_, i) =>
          Array.from({ length: 14 }).map((_, j) => {
            const x = (i - 4.5) * 60;
            const y = (j - 6.5) * 56;
            const facets = 6;
            
            return (
              <g key={`${i}-${j}`}>
                {Array.from({ length: facets }).map((_, k) => {
                  const angle = (k * Math.PI * 2) / facets;
                  const nextAngle = ((k + 1) * Math.PI * 2) / facets;
                  const r = 22;
                  
                  return (
                    <path
                      key={k}
                      d={`M ${x} ${y} L ${x + Math.cos(angle) * r} ${y + Math.sin(angle) * r} L ${x + Math.cos(nextAngle) * r} ${y + Math.sin(nextAngle) * r} Z`}
                      fill={k % 2 === 0 ? cartierRed : cartierGold}
                      opacity={0.2}
                      stroke={cartierGold}
                      strokeWidth="0.5"
                    />
                  );
                })}
              </g>
            );
          })
        )}

        {/* Ruby red precision circles */}
        {Array.from({ length: 15 }).map((_, i) => {
          const r = 40 + i * 18;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={i % 2 === 0 ? cartierRed : cartierGold}
              strokeWidth="1"
              opacity={0.3 - i * 0.015}
            />
          );
        })}

        {/* Geometric frame (Panthère inspiration) */}
        <rect x="-180" y="-160" width="360" height="320" fill="none" stroke={cartierGold} strokeWidth="3" opacity="0.6" rx="8" />
        <rect x="-170" y="-150" width="340" height="300" fill="none" stroke={cartierRed} strokeWidth="1" opacity="0.4" rx="6" />

        {/* Jewelry precision nodes */}
        {[
          { x: 0, y: -180, r: 15 },
          { x: -160, y: 0, r: 12 },
          { x: 160, y: 0, r: 12 },
          { x: 0, y: 180, r: 15 },
        ].map((gem, i) => (
          <g key={i}>
            {/* Faceted gemstone */}
            {Array.from({ length: 8 }).map((_, k) => {
              const angle = (k * Math.PI * 2) / 8;
              const nextAngle = ((k + 1) * Math.PI * 2) / 8;
              
              return (
                <path
                  key={k}
                  d={`M ${gem.x} ${gem.y} L ${gem.x + Math.cos(angle) * gem.r} ${gem.y + Math.sin(angle) * gem.r} L ${gem.x + Math.cos(nextAngle) * gem.r} ${gem.y + Math.sin(nextAngle) * gem.r} Z`}
                  fill={cartierRed}
                  opacity={0.4}
                  stroke={cartierGold}
                  strokeWidth="1"
                />
              );
            })}
          </g>
        ))}

        {/* Millimetric precision lines */}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i * Math.PI) / 12;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 260}
              y2={Math.sin(angle) * 260}
              stroke={cartierGold}
              strokeWidth="0.5"
              opacity="0.2"
              strokeDasharray="2 2"
            />
          );
        })}

        {/* Central medallion */}
        <circle cx="0" cy="0" r="50" fill={cartierRed} opacity="0.3" />
        <circle cx="0" cy="0" r="50" fill="none" stroke={cartierGold} strokeWidth="2" opacity="0.6" />
      </g>

      {/* Cartier inscription */}
      <text x="397" y="1030" textAnchor="middle" fontFamily="serif" fontSize="11" fill={cartierGold} opacity="0.7" fontStyle="italic">
        précision joaillière
      </text>
    </g>
  );
}
